var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogoDarkbackground = function SvgLogoDarkbackground(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 18,
    viewBox: "0 0 161 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_4391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6139 0H17.4253C16.5439 0.00271849 15.6717 0.177229 14.8585 0.513565C14.0453 0.849901 13.3071 1.34147 12.686 1.96019C12.0648 2.57891 11.573 3.31266 11.2385 4.11952C10.904 4.92637 10.7335 5.79052 10.7367 6.6626V9.36734C10.7359 9.58526 10.6478 9.79397 10.4918 9.94778C10.3358 10.1016 10.1246 10.188 9.90433 10.188V10.188C9.68716 10.188 9.47857 10.1041 9.32306 9.95411C9.16756 9.80412 9.07746 9.59993 9.07199 9.38512L9.02708 7.31139L6.2666 16.7617L10.7367 18H15.6169C19.587 18 21.2846 13.9562 21.2846 10.973V6.13232V5.15174C21.2842 5.04256 21.3056 4.93438 21.3475 4.8334C21.3895 4.73242 21.4512 4.64063 21.529 4.56329C21.6069 4.48595 21.6995 4.42458 21.8014 4.38271C21.9033 4.34084 22.0125 4.31929 22.1229 4.31929C22.3455 4.32007 22.5587 4.40812 22.7159 4.56415C22.873 4.72018 22.9612 4.93148 22.9612 5.15174",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34884 0.121498C8.23807 -0.42656 10.7291 0.974688 10.7291 2.924V11.8114C10.7316 13.1964 11.1819 14.5443 12.0142 15.6578C12.8465 16.7714 14.0172 17.5921 15.3548 18H10.7291C6.47759 18 2.40274 14.5606 2.40274 10.3568V2.52703C2.42032 2.29386 2.35563 2.06188 2.21968 1.87064C2.08373 1.6794 1.88495 1.54074 1.65723 1.47831L6.34884 0.121498Z",
    fill: "url(#paint0_linear_393_4391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 18C31.7811 17.9233 31.5914 17.7813 31.4573 17.5935C31.3233 17.4056 31.2514 17.1812 31.2517 16.9513V7.50099C31.2517 5.5116 30.453 3.6037 29.0313 2.19699C27.6096 0.790282 25.6814 0 23.6709 0H18.4224C19.7572 0.411189 20.9242 1.23374 21.7531 2.3476C22.5821 3.46146 23.0295 4.80831 23.0301 6.19157V14.4865C23.0294 14.9474 23.1204 15.4039 23.298 15.8299C23.4756 16.256 23.7363 16.6432 24.0653 16.9695C24.3942 17.2958 24.7849 17.5548 25.215 17.7316C25.6452 17.9084 26.1063 17.9996 26.5721 18H32.0002Z",
    fill: "url(#paint1_linear_393_4391)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_393_4391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6052 10.2389C57.6052 10.9789 57.4552 11.7117 57.1635 12.3954C56.8719 13.079 56.4445 13.7002 55.9057 14.2235C55.3669 14.7468 54.7272 15.1618 54.0232 15.445C53.3192 15.7282 52.5646 15.874 51.8026 15.874C51.0406 15.874 50.2861 15.7282 49.5821 15.445C48.878 15.1618 48.2384 14.7468 47.6995 14.2235C47.1607 13.7002 46.7333 13.079 46.4417 12.3954C46.1501 11.7117 46 10.9789 46 10.2389V2.69995H48.6743V10.2389C48.6539 10.6497 48.7197 11.0602 48.8676 11.4455C49.0154 11.8309 49.2423 12.1831 49.5345 12.4807C49.8266 12.7784 50.178 13.0154 50.5672 13.1773C50.9565 13.3392 51.3756 13.4227 51.799 13.4227C52.2225 13.4227 52.6415 13.3392 53.0308 13.1773C53.42 13.0154 53.7714 12.7784 54.0636 12.4807C54.3557 12.1831 54.5826 11.8309 54.7305 11.4455C54.8783 11.0602 54.9441 10.6497 54.9238 10.2389V2.69995H57.6052V10.2389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7617 2.69995H68.4753L76.6855 10.47V2.69995H79.367V16H78.6317L70.436 8.22995V16H67.7617V2.69995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.401 16H97.2577L94.9511 12.451H92.8823V16H90.2441V2.69995H95.0736C95.723 2.71176 96.3636 2.84805 96.9585 3.10099C97.5535 3.35392 98.0912 3.71852 98.5406 4.17384C98.99 4.62916 99.3424 5.16622 99.5775 5.75418C99.8125 6.34214 99.9257 6.96941 99.9104 7.59995C99.9177 8.42132 99.7123 9.23129 99.313 9.95541C98.9137 10.6795 98.3334 11.2946 97.6254 11.7439L100.401 16ZM95.0736 9.79095C95.6565 9.75912 96.2048 9.51183 96.6058 9.09984C97.0069 8.68785 97.2304 8.1424 97.2304 7.57545C97.2304 7.0085 97.0069 6.46306 96.6058 6.05106C96.2048 5.63907 95.6565 5.39178 95.0736 5.35995H92.9112V9.79095H95.0736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.108 2.69995H119.264V5.35995H111.876V8.14595H117.412V10.806H111.876V13.34H119.264V16H109.108V2.69995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.244 13.788H131.446L130.25 16H127.237L134.848 2L142.468 16H139.462L138.244 13.788ZM136.802 11.135L134.856 7.523L132.902 11.135H136.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.829 2.91699H153.604V13.382H161V16H150.829V2.91699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_4391",
    x1: 13.8815,
    y1: 18.0379,
    x2: 4.53029,
    y2: 0.541474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB23DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_393_4391",
    x1: 21.6258,
    y1: -1.29872,
    x2: 31.0124,
    y2: 16.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E53F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AF0BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_4391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_393_4391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 14,
    fill: "white",
    transform: "translate(46 2)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDarkbackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_darkbackground.321c8911c641693eaf60880fcf682616.svg";